import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';
import { FaltaDocumentoParams } from '@core/models';


@Injectable({
  providedIn: 'root',
})
export class DocumentFaltaService {

  private readonly endpoint = '/api/Documento/Falta';

  constructor( private readonly apiService: ApiService, ) {}

  gerarDocumento( params: FaltaDocumentoParams, ): Observable<Blob> {

    let httpParams = new HttpParams();

    if (params.PeriodoEnum !== undefined && params.PeriodoEnum !== null) {
      httpParams = httpParams.set(
        'PeriodoEnum',
        params.PeriodoEnum.toString()
      );
    }

    if(params.EstadoEfetivo !== undefined && params.EstadoEfetivo !== null){
      httpParams = httpParams.set('EstadoEfetivo', params.EstadoEfetivo.toString());
    }

    if (params.formatoDocumento !== undefined && params.formatoDocumento !== null) {
      httpParams = httpParams.set(
        'formatoDocumento',
        params.formatoDocumento.toString()
      );
    }

    if (params.DataAdmissaoDe) {
      httpParams = httpParams.set(
        'DataAdmissaoDe',
        params.DataAdmissaoDe
      );
    }

    if (params.DataAdmissaoAte) {
      httpParams = httpParams.set(
        'DataAdmissaoAte',
        params.DataAdmissaoAte
      );
    }

    if ( params.ClienteId !== undefined && params.ClienteId !== null) {
      httpParams = httpParams.set(
        'ClienteId',
        params.ClienteId.toString()
      );
    }

    if (params.PostoId !== undefined && params.PostoId !== null) {
      httpParams = httpParams.set(
        'PostoId',
        params.PostoId.toString()
      );
    }

    return this.apiService.get<Blob>(
      this.endpoint,
      httpParams,
      {
        responseType: 'blob'
      }
    );
  }
}
